import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { validateEnvironment } from './lib/config'

// Validate environment on startup
const validationResult = validateEnvironment()
if (validationResult.errors.length > 0) {
  console.error('Environment validation errors:', validationResult.errors)
  // Continue loading app but log errors for debugging
}

if (validationResult.warnings.length > 0) {
  console.warn('Environment validation warnings:', validationResult.warnings)
}

createRoot(document.getElementById("root")!).render(<App />);
